// extracted by mini-css-extract-plugin
export default {"error":"price_error__Huhsa","title":"price_title__liUf+","nav":"price_nav__IzqVG","buttons":"price_buttons__Sa0Za","active":"price_active__51oaj"};